const map = {
	"./1x/1x/Asset 2.png": 8565,
	"./1x/Asset 1.png": 752,
	"./1x/Asset 2.png": 5787,
	"./4x/Asset 1@4x.png": 4099,
	"./4x/Asset 2@4x.png": 8618,
	"./4x/Asset 4@4x.png": 5900,
	"./4x/Asset 5@4x.png": 6799,
	"./4x/logo-response.png": 1133,
	"./800w/Asset 4.png": 817,
	"./800w/Asset 6.png": 1651,
	"./Ind.jpg": 1108,
	"./aboutus.jpg": 6652,
	"./brk2.png": 2316,
	"./brk3.png": 1413,
	"./brk4.webp": 9134,
	"./clients/global.png": 1861,
	"./clients/jmi.png": 7374,
	"./clients/maruf.png": 9267,
	"./clients/nipro.png": 3574,
	"./clients/oksmart.jpeg": 5848,
	"./clients/unix.png": 870,
	"./contact-us-banner.jpg": 9739,
	"./contact-us-banner2.jpg": 1457,
	"./earning.png": 4169,
	"./footer.jpg": 8958,
	"./individuality.png": 788,
	"./logo-earning.png": 1971,
	"./logo-response.png": 7496,
	"./logo-team.png": 5550,
	"./logo.png": 2806,
	"./logo1.png": 2861,
	"./responsibility.png": 3337,
	"./service.jpg": 854,
	"./services/service1.jpg": 2898,
	"./services/service2.jpg": 8829,
	"./services/service3.jpg": 256,
	"./slide1.jpg": 5247,
	"./slide2.jpg": 912,
	"./slide3.jpg": 5485,
	"./slide4.jpg": 4038,
	"./slide5.jpg": 2563,
	"./slide6.png": 304,
	"./team.png": 9880,
	"./vision.jpg": 9859,
	"./vision2.jpg": 2201
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;